import axiosInstance from './AxiosInstance';
import { cachedRequest } from './requestCache';

const API_URL = '/trainerdirectory';

// Read-only roster (id, userId, trainerName, specialization, experience) —
// userId is the same account id the chat system (SocketContext/ChatService)
// keys everyone by, so it doubles as the "chat id" to start a DIRECT chat
// with a given trainer.
//
// Shared for five minutes. The dashboard's online-trainers tile and the
// chat both read it, the tile on every visit to /dashboard (twice in
// development, where StrictMode mounts it twice) -- for a roster that
// changes a few times a month. One request serves them all; a failure is
// not kept, so the next caller simply asks again.
export const getTrainerDirectory = async () =>
  cachedRequest('trainerdirectory:roster', 5 * 60 * 1000, async () => {
    const response = await axiosInstance.get(API_URL);
    return response.data.data || [];
  });
